import { render, staticRenderFns } from "./ReporteHotel.vue?vue&type=template&id=354a6226&"
import script from "./ReporteHotel.vue?vue&type=script&lang=js&"
export * from "./ReporteHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports